// extracted by mini-css-extract-plugin
export default {"content":"search-page_content__IVSIK","title":"search-page_title__jO4FP","cards_box":"search-page_cards_box__6-NGw"};